import router from '@/router'
import {getInfoByWxCode} from '@/api/home'
import {Toast} from "vant";
import {
    clearUrlBeforeLogin,
    getAuthToken,
    getUrlBeforeLogin,
    getWxInfo,
    getWxLoginCode,
    setAuthToken,
    setECardList,
    setUrlBeforeLogin,
    setWxInfo,
    setWxLoginCode
} from "@/utils/storage";
import process from "shelljs";

function isSubscribed(userInfo) {
    if (!userInfo) {
        return false
    }
    // 兼容旧字段 subscribe 与当前后端 izSubscribe
    return userInfo.subscribe == 1
        || userInfo.subscribe === '1'
        || userInfo.izSubscribe == 1
        || userInfo.izSubscribe === '1'
}

function cacheLoginResult(data) {
    if (!data) {
        return null
    }
    const token = data.token
    const userInfo = data.userinfo || data.fUserVo
    if (token) {
        setAuthToken(token)
    }
    if (userInfo) {
        setWxInfo(userInfo)
    }
    // 有健康卡列表才覆盖缓存；刷新登录可能不带 list
    if (data.list) {
        setECardList(JSON.stringify(data.list))
    }
    return userInfo
}

/** 去掉 URL 中的 code/state，避免复用已失效的微信授权码 */
function getCleanRedirectUrl() {
    try {
        const url = new URL(window.location.href)
        url.searchParams.delete('code')
        url.searchParams.delete('state')
        return url.toString()
    } catch (e) {
        return window.location.href.split('?')[0]
    }
}

/**
 * 归一成 router 相对路径：router 会自动补部署 base（如 /dist/），
 * 传真实 URL 或带 base 的 pathname 都会变成 /dist/dist/xxx 而匹配不到路由。
 */
function normalizeTargetPath(input) {
    let path = (input || window.location.href || '').split('#')[0]
    const schemeIndex = path.indexOf('://')
    if (schemeIndex > -1) {
        const afterHost = path.slice(schemeIndex + 3)
        const slashIndex = afterHost.indexOf('/')
        path = slashIndex > -1 ? afterHost.slice(slashIndex) : '/'
    }
    const base = (process.env.VUE_APP_PATH || '').replace(/\/+$/, '')
    if (base && (path === base || path.indexOf(base + '/') === 0)) {
        path = path.slice(base.length)
    }
    if (path.indexOf('/') !== 0) {
        path = '/' + path
    }
    const segments = path.split('?')
    const pathname = segments[0] || '/'
    const query = (segments[1] || '').split('&')
        .filter(item => item && item.split('=')[0] !== 'code' && item.split('=')[0] !== 'state')
    return query.length ? pathname + '?' + query.join('&') : pathname
}

function redirectToWechatOAuth(redirectUri) {
    const appid = process.env.VUE_APP_APPID
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect`
}

export function wxAuthLogin(path) {
    let code = ''
    const local = getCleanRedirectUrl()
    setUrlBeforeLogin(normalizeTargetPath(path))
    // 截取 code
    code = getUrlCode().code
    // 同一 code 已换过 token，避免重复请求
    if (code && code === getWxLoginCode() && getAuthToken() && getWxInfo().openid) {
        return
    }
    // code 已使用但 token 失效，重新走微信授权
    if (code && code === getWxLoginCode() && !getAuthToken()) {
        redirectToWechatOAuth(local)
        return
    }
    if (code) {
        setWxLoginCode(code)
    }
    if (!code) {
        redirectToWechatOAuth(local)
    } else {
        getInfoByWxCode(code).then(res => {
            if (res.code === 200 || res.code === 0) {
                let userInfo = cacheLoginResult(res.data)
                if (!userInfo || !userInfo.openid) {
                    Toast.fail('登录失败：未获取到用户信息')
                    return
                }
                if (isSubscribed(userInfo)) {
                    let targetPath = getUrlBeforeLogin() || '/home/homepage'
                    clearUrlBeforeLogin()
                    router.replace({path: targetPath}).then()
                } else {
                    clearUrlBeforeLogin()
                    router.replace({path: '/not'}).then()
                }
            } else {
                Toast.fail(res.msg || res.message || '登录失败')
            }
        }).catch(() => {
            Toast.fail('登录失败，请重试')
        })
    }
}

export function getUrlCode() {
    const url = location.search
    const theRequest = {}
    if (url.indexOf("?") !== -1) {
        let str = url.substr(1)
        let strs = str.split("&")
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
        }
    }
    return theRequest
}


export function buildWechatAuthRefUrl(redirectUri) {
    const callbackUrl = (redirectUri || '').replace(/\s/g, '')
    return 'https://health.tengmed.com/api/v2/wechat/code?isv_app_id='
        + process.env.VUE_APP_HOSPITAL_APPID_ID
        + '&hospital_id=' + process.env.VUE_APP_HOSPITAL_ID
        + '&redirect_uri=' + encodeURIComponent(callbackUrl)
}

export function getWechatCode(url) {
    const refUrl = buildWechatAuthRefUrl(url)
    console.log('callbackUrl', url)
    console.log('refUrl', refUrl)
    window.location.assign(refUrl)
}



// WEBPACK FOOTER //
// ./src/utils/wxLogin.js